"use client";

import React, { ComponentPropsWithRef, ReactNode, forwardRef, useState } from "react";
import { UseFormSetValue } from "react-hook-form";

interface RecaptchaFormProps extends ComponentPropsWithRef<"form"> {
  children: ReactNode;
  setValue: UseFormSetValue<any>;
  regenerateToken?: boolean;
}

const RecaptchaForm = forwardRef<HTMLFormElement, RecaptchaFormProps>(({ children, setValue, regenerateToken, ...rest }, ref) => {
  // const [hcaptchaToken, setHcaptchaToken] = useState<string | null>(null);

  // // Set hCaptcha token in form value when received
  // React.useEffect(() => {
  //   console.log("hCaptcha token received:", hcaptchaToken);
  //   if (hcaptchaToken) {
  //     console.log("hCaptcha token received:", hcaptchaToken);
  //     setValue("token", hcaptchaToken);
  //   }
  // }, [hcaptchaToken, setValue]);

  return (
    <form ref={ref} {...rest}>
      <fieldset>{children}</fieldset>
    </form>
  );
});
RecaptchaForm.displayName = "RecaptchaForm";
export default RecaptchaForm;
